import { render, staticRenderFns } from "./WebHookSettings.vue?vue&type=template&id=02218982&"
import script from "./WebHookSettings.vue?vue&type=script&lang=ts&"
export * from "./WebHookSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports